export const GET_FEATURE_REQUESTS = "GET_FEATURE_REQUESTS";
export const GET_FEATURES_REQUESTS_BY_DEPARTMENT = "GET_FEATURES_REQUESTS_BY_DEPARTMENT";
export const ADD_FEATURE_REQUEST = "ADD_FEATURE_REQUEST";
export const START_FETCHING_FEATURE_REQUESTS = "START_FETCHING_FEATURE_REQUESTS";
export const STOP_FETCHING_FEATURE_REQUESTS = "STOP_FETCHING_FEATURE_REQUESTS";